import { render, staticRenderFns } from "./LsInput.vue?vue&type=template&id=2e95a0d2&"
import script from "./LsInput.vue?vue&type=script&lang=js&"
export * from "./LsInput.vue?vue&type=script&lang=js&"
import style0 from "./LsInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports